<template>
  <div class="bar-chart-wrapper">
    <Bar class="plotted-chart" :data="data" :options="options" />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, nextTick } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  scales,
  LinearScale,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  scales,
  ChartDataLabels,
);

export default defineComponent({
  name: "barChart",
  components: { Bar },
  props: ["data"],
  setup() {
    const chartContainer = ref(null);
    const canvasReady = ref(false);

    onMounted(async () => {
      await nextTick();
      if (chartContainer.value) {
        canvasReady.value =
          chartContainer.value.offsetWidth > 0 &&
          chartContainer.value.offsetHeight > 0;
      }
    });

    return { chartContainer, canvasReady };
  },
  data() {
    return {
      options: {
        plugins: {
          skipNull: true,
          datalabels: {
            clip: true,
            color: "#ffffff",
            font: {
              weight: "bold",
              size: 20,
            },
            align: "center",
          },
          tooltips: { enabled: false },
          hiver: { mode: null },
          legend: { display: true },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          display: true,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
              fontSize: 10,
              fontColor: "#6C757D",
              maxTicksLimit: 6,
              padding: 10,
            },
            grid: {
              drawTicks: true,
              drawBorder: true,
              offsetGridLines: true,
            },
            stacked: true,
          },
          x: {
            display: true,
            ticks: {
              fontSize: 10,
              fontColor: "#6C757D",
              autoSkip: true,
            },
            grid: {
              display: false,
            },
            stacked: true,
          },
        },
      },
    };
  },
});
</script>

<style lang="scss">

.bar-chart-wrapper {
  @media (min-width: 50px) {
    height: 100%;
    width: 100%;
  }
  @media (min-width: 768px) {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
  }
}
.plotted-chart {
  @media (min-width: 50px) {
    margin-top: 30px;
    width: 100%;           // Changed from max-content
    height: auto;          // Changed from max-content
    overflow-x: hidden;    // Changed from scroll
  }
  @media (min-width: 768px) {
    margin-top: 30px;
    width: 100%;           // Changed from 90vw
    height: 50vh;
    overflow-x: hidden;    // Changed from scroll
  }
}
</style>
